import Openable from './lib/openable';

class Modal extends Openable {
  constructor(element, useOverlay = true) {
    super(element, useOverlay);

    this.classes = {
      active: 'modal--active',
    };
    this.closeTransitionProperty = 'opacity';
  }
}

export default (element, useOverlay = true) => new Modal(element, useOverlay);
